import { addVisible, removeVisible } from './helper';

const CLS = '.validate--tooltip-required';
export function validateRequired(element: HTMLInputElement): boolean {
    if (element.type === 'checkbox') {
        if (element.checked === false) {
            addVisible(element, CLS);
            return false;
        }
    }
    if (element.value === '') {
        addVisible(element, CLS);
        return false;
    } else {
        removeVisible(element, CLS);
        return true;
    }
}

export function liveValidateRequired(element: HTMLInputElement) {
    function validate(this: HTMLInputElement, e: InputEvent) {
        validateRequired(this);
    }

    if (element.hasAttribute('required')) {
        element.addEventListener('change', validate);
        element.addEventListener('input', validate);
        element.addEventListener('blur', validate);
    }
}
